var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-row",
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "transition",
                    { attrs: { mode: "out-in", name: "fast-fade" } },
                    [
                      _vm.tab == 0
                        ? _c("app-heading-settings", {
                            key: "0",
                            attrs: {
                              heading: _vm.heading,
                              lang: _vm.selectedLanguage,
                              fields: _vm.fields,
                            },
                            on: {
                              "update:lang": function ($event) {
                                _vm.selectedLanguage = $event
                              },
                              "convert-to-free-block": function ($event) {
                                return _vm.convertToFreeBlock()
                              },
                              "reset-to-default": function ($event) {
                                return _vm.reset()
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.tab == 1
                        ? _c("app-client-heading-settings", {
                            key: "1",
                            attrs: {
                              "show-reset-button": "",
                              "contact-group-id": _vm.contactGroupId,
                              heading: _vm.clientHeading,
                              lang: _vm.selectedLanguage,
                            },
                            on: {
                              "update:lang": function ($event) {
                                _vm.selectedLanguage = $event
                              },
                              "convert-to-free-block": function ($event) {
                                return _vm.convertClientToFreeBlock(
                                  _vm.clientHeading,
                                  false
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.tab == 2
                        ? _c("app-client-heading-settings", {
                            key: "2",
                            attrs: {
                              "show-reset-button": "",
                              "contact-group-id": _vm.contactGroupId,
                              heading: _vm.deliveryAddressHeading,
                              lang: _vm.selectedLanguage,
                              "is-delivery-address": "",
                            },
                            on: {
                              "update:lang": function ($event) {
                                _vm.selectedLanguage = $event
                              },
                              "convert-to-free-block": function ($event) {
                                return _vm.convertClientToFreeBlock(
                                  _vm.deliveryAddressHeading,
                                  true
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }